<div class="flex flex-col min-h-screen bg-white">
  <!-- Contenu principal -->
  <main class="flex-grow">
    <app-side-bar></app-side-bar>
    <app-navbar></app-navbar>
    <div class="sm:ml-64">
      <div class="p-3 ">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>

</div>
